import type {
  DrillChildrenAction,
  DrillScope,
  EntityDrilldownState,
  ParentGrain,
} from "src/pages/ad-studio/insights/performance/types";
import { channelOf } from "src/pages/ad-studio/insights/performance/utils/drill";
import { getEntityLabel } from "src/pages/ad-studio/insights/shared/channels";
import { useDrillChildren } from "src/pages/ad-studio/insights/use-drill-children";
import { useParentEntity } from "src/pages/ad-studio/insights/use-parent-entity";

export function useEntityDrilldown({
  drill,
  grain,
  id,
}: {
  drill: DrillScope;
  grain: ParentGrain;
  id: string;
}): {
  state: EntityDrilldownState;
  performAction: (action: DrillChildrenAction) => void;
} {
  const entity = useParentEntity({ drill, grain, id });
  const children = useDrillChildren({ drill, grain, id });
  return {
    state: {
      header: entity.state,
      notFoundHeading: getEntityLabel(channelOf(drill), grain),
      childList: children.state,
    },
    performAction: children.performAction,
  };
}
